import { Component, createRef } from 'react';
import { connect } from 'react-redux';
import { bool, number, string } from 'prop-types';

import {
  ESCAPE,
  MONEY_SHOT,
  OPEN_DETAIL_VIEW,
  OPEN_PURCHASE,
  POP_WINDOW,
  RADAR_CARD_FLIPPED,
  RADAR_OPENED,
  RADAR_SUPER_LIKE,
  RADAR_SWIPE,
  SHRED,
  TAB_PUSH,
} from '~/redux/actions/SoundActions';
import { soundSelector } from '~/redux/selectors';
import {
  EARN_COINS_PATH,
  HOME_PATH,
  OPEN_CARDS_PATH,
  RADAR_PATH,
} from '~/routes/paths';
import { mainViewTabPaths } from '~/routes/routeComponents';

import escape from '~/assets/sounds/escape.mp3';
import moneyShot from '~/assets/sounds/money_shot.mp3';
import openDetailView from '~/assets/sounds/open_detail_view.mp3';
import openPurchase from '~/assets/sounds/open_purchase.mp3';
import popWindow from '~/assets/sounds/pop_window.mp3';
import cardFlipped from '~/assets/sounds/radar_card_flipped.wav';
import radarOpened from '~/assets/sounds/radar_opened.wav';
import superlike from '~/assets/sounds/radar_super_like.wav';
import swipe from '~/assets/sounds/radar_swiping.wav';
import shred from '~/assets/sounds/shred.mp3';
import tabPush from '~/assets/sounds/tab_push.mp3';

import SoundItem from './SoundItem';

const mainViewTabDetailsPaths = mainViewTabPaths.filter(
  (path) => path !== HOME_PATH,
);

const popupPath = ['/menu', EARN_COINS_PATH]; // TODO: why only theese 2 modals are checked?

const sounds = {
  [TAB_PUSH]: tabPush,
  [POP_WINDOW]: popWindow,
  [ESCAPE]: escape,
  [SHRED]: shred,
  [OPEN_DETAIL_VIEW]: openDetailView,
  [OPEN_PURCHASE]: openPurchase,
  [MONEY_SHOT]: moneyShot,
  [RADAR_OPENED]: radarOpened,
  [RADAR_CARD_FLIPPED]: cardFlipped,
  [RADAR_SUPER_LIKE]: superlike,
  [RADAR_SWIPE]: swipe,
};

class SoundContainer extends Component {
  static propTypes = {
    pathname: string.isRequired,
    counter: number.isRequired,
    type: string.isRequired,
    mute: bool,
  };

  constructor(props) {
    super(props);
    this.sounds = Object.fromEntries(
      Object.keys(sounds).map((key) => [key, createRef()]),
    );
  }

  getSoundAfterLocationChange = (beforePathname) => {
    const { pathname: afterPathname } = this.props;
    if (beforePathname !== afterPathname) {
      if (afterPathname === OPEN_CARDS_PATH) {
        // open cards from loot
        return OPEN_PURCHASE;
      }
      if (afterPathname === RADAR_PATH) {
        // open cards from loot
        return RADAR_OPENED;
      }
      if (mainViewTabPaths.includes(afterPathname)) {
        if (
          !mainViewTabPaths.includes(beforePathname) &&
          mainViewTabPaths.some((path) => beforePathname.includes(path))
        ) {
          return ESCAPE;
        }
        return TAB_PUSH;
      }
      if (
        mainViewTabDetailsPaths.includes(beforePathname) &&
        mainViewTabDetailsPaths.some((path) => afterPathname.includes(path))
      ) {
        return OPEN_DETAIL_VIEW;
      }
      if (popupPath.includes(beforePathname)) {
        // popup close
        return ESCAPE;
      }
      return POP_WINDOW;
    }
    return '';
  };

  shouldComponentUpdate(nextProps) {
    return !this.props.mute || !nextProps.mute;
  }

  componentDidUpdate(prevProps) {
    if (this.props === prevProps || this.props.mute) return;
    let soundToPlay;
    if (this.props.counter !== prevProps.counter) {
      soundToPlay = this.props.type;
    } else {
      soundToPlay = this.getSoundAfterLocationChange(prevProps.pathname);
    }
    if (soundToPlay && this.sounds[soundToPlay]) {
      this.sounds[soundToPlay].current.play();
    }
  }

  render() {
    return Object.entries(this.sounds).map(([key, ref]) => (
      <SoundItem
        key={key}
        url={sounds[key]}
        ref={ref}
      />
    ));
  }
}

export default connect(soundSelector)(SoundContainer);
